import React, { useContext, useEffect, useState } from "react";
import { mainContext } from "../../context/context";
import Loading from "../Loader/Loading";
import EmployerForm from "../InformationsForms/EmployerForm";
import ReferredByForm from "../InformationsForms/ReferredByForm";
import ProceduresForm from "../InformationsForms/ProceduresForm";
import SpecialInstructions from "../InformationsForms/SpecialInstructions";
import ReportForm from "../CustomerList/ReportForm";
import AppointmentForm from "../CustomerList/AppointmentForm";
import { baseUrl } from "../../common/constants";
import FormButtons from "../InformationsForms/FormButtons";
import { toast } from "react-toastify";
import _axios from "../../utils/api/_axios";
import { EditOutlined } from "@ant-design/icons";
import { Content } from "antd/es/layout/layout";
import { Checkbox, Col, Form, Input, Row } from "antd";

const Claim = ({patientId="", claim, handleClaim, isModal,fetchClaims,setSelectedClaim }) => { 
  const [isEditing, setIsEditing] = useState(false);
  const { isLoading ,selectedPatient} = useContext(mainContext);
  const [formValues, setFormValues] = useState({
    isRush: false,
    isTranslationRequired: false,
    isTransportationRequired: false,
    injury: "",
    dateOfInjury: "",
  });

  const inputChangeHandler = (event) => {
    const { name, value } = event.target;
    setFormValues({ ...formValues, [name]: value });
  };

  const handleFieldChange = (fieldName) => {
    setFormValues((prevValues) => ({
      ...prevValues,
      [fieldName]: !prevValues[fieldName],
    }));
  };

  const handleEditClose = () => {
    setIsEditing(false);
  };

const setValues = (claim) => {
  const formattedDate = claim?.dateOfInjury ? 
    new Date(claim.dateOfInjury).toISOString().split('T')[0] : '';

  setFormValues({
    ...formValues,
    isRush: claim.isRush,
    isTranslationRequired: claim.isTranslationRequired,
    isTransportationRequired: claim.isTransportationRequired,
    injury: claim.injury,
    dateOfInjury: formattedDate
  });
};

  const handleSubmit = async (event) => {
    event.preventDefault();
    let claimId;
    if (patientId && claim?._id) {
      claimId = claim?._id;
    }
    if (patientId && claimId) {
      try {
        const claimUpdate = {
          multipleUpdates: {
            isRush: formValues.isRush,
            isTranslationRequired: formValues.isTranslationRequired,
            isTransportationRequired: formValues.isTransportationRequired,
            injury: formValues.injury,
            dateOfInjury: formValues.dateOfInjury,
          },
        };
        let res = await _axios.put(
          `${baseUrl}/patients/${patientId}/claims/${claimId}`,
          claimUpdate,
          {
            headers: {
              "Content-Type": "application/json",
            },
            cache: "no-cache",
          }
        );
        if (res.status === 200) {
          toast.success("Successfully Updated.");
        } else {
          toast.error("Unable to submit. Some error occured");
        }
      } catch (err) {
        console.log(err);
      }
    } else {
      toast.error("Unable to submit. please select a patient to bind with");
    }
    handleEditClose();
  };

  useEffect(() => {
    if (claim) {
      setValues(claim);
      const formattedDate = claim?.dateOfInjury ? 
        new Date(claim.dateOfInjury).toISOString().split('T')[0] : '';

      setFormValues({
        ...formValues,
        isRush: claim?.isRush,
        isTranslationRequired: claim?.isTranslationRequired,
        isTransportationRequired: claim?.isTransportationRequired,
        injury: claim?.injury,
        dateOfInjury: formattedDate
      });
    } else {
      setFormValues({
        ...formValues,
        isRush: false,
        isTranslationRequired: false,
        isTransportationRequired: false,
        dateOfInjury: ''
      });
    }
  }, [claim]);

  return (
    <Content>
    <>
      {isLoading && (
        <div className="flex justify-center items-center h-20">
          <Loading isCircular={true} />
        </div>
      )}
  
      <div >
        {/* Header Section */}
        <div className="bg-yellow-100 p-4 rounded-lg shadow-sm flex justify-between items-start">
  {/* Left Section */}
  <div className="space-y-1">
    <div className="text-lg font-semibold text-gray-800">
      Claim: <span className="font-normal">{claim?.claimNumber}</span>
    </div>
    <div className="text-gray-700">
      <b>Status:</b> {claim?.status === "PaymentAwaited" ? "Payment Awaited" : claim?.status}
    </div>
    <div className="text-gray-700">
      <b>Date Of Injury:</b>{" "}
      {claim?.dateOfInjury
        ? new Date(claim?.dateOfInjury).toLocaleDateString("en-US", {
            year: "numeric",
            month: "2-digit",
            day: "2-digit",
          })
        : "Not available"}
    </div>
    <div className="text-gray-700">
      <b>Claim Creation Date:</b>{" "}
      {claim?.createdAt
        ? new Date(claim?.createdAt).toLocaleDateString("en-US", {
            year: "numeric",
            month: "2-digit",
            day: "2-digit",
          })
        : "Not available"}
    </div>
    <div className="text-gray-700">
      <b>Injury/Jurisdiction State:</b> {formValues?.injury || "Not available"}
    </div>
    {/* Claim ID Below Injury */}
    <div className="text-gray-800 font-medium">
      <b>Claim ID:</b> <span className="text-blue-600">RSS-RF#{claim?.claimUniqueId}</span>
    </div>
  </div>

  {/* Claim History Button */}
  {!isModal && (
  <div
  className="cursor-pointer text-blue-600 font-semibold hover:underline"
  onClick={() => {
    const element = document.getElementById("ClientHistory");
    if (element) {
      element.scrollIntoView({ behavior: "smooth", block: "start" });
    }
  }}
>
  Claim History
</div>

 
  )}
</div>

  
        {/* Forms Section */}
        <hr className="border-t border-gray-300 my-4" />
        <EmployerForm isForm={false} patientId={patientId} claim={claim} fetchClaims={fetchClaims} setSelectedClaim={setSelectedClaim}/>
        <ReferredByForm isForm={false} patientId={patientId} claim={claim} fetchClaims={fetchClaims} setSelectedClaim={setSelectedClaim}/>
        <ProceduresForm isForm={false} patientId={patientId} claim={claim} fetchClaims={fetchClaims} setSelectedClaim={setSelectedClaim}/>
        {(claim?.adjusterInfo?.adjusterId && claim?.status !== "Unassigned" && claim?.adjusterInfo?.insuranceCompanyId) &&
        <>
          <AppointmentForm isForm={false} patientId={patientId} claim={claim} fetchClaims={fetchClaims} setSelectedClaim={setSelectedClaim}/>
        </>
        }
        <SpecialInstructions isForm={false} patientId={patientId} claim={claim} fetchClaims={fetchClaims} setSelectedClaim={setSelectedClaim}/>
        <ReportForm isForm={false} patientId={patientId} claim={claim} fetchClaims={fetchClaims} setSelectedClaim={setSelectedClaim}/>
  
        {/* Miscellaneous Section */}
        <div className="mt-6 p-4 border border-gray-300 rounded-lg bg-gray-50">
          <div className="flex justify-between items-center">
            <h4 className="text-lg font-semibold text-gray-800">Miscellaneous</h4>
            {!isEditing && (
              <div
                className="cursor-pointer text-blue-600 flex items-center gap-1 hover:underline"
                onClick={() => setIsEditing(true)}
              >
                <EditOutlined className="text-xl" />
                <span>Edit</span>
              </div>
            )}
          </div>
  
          {isEditing ? (
            <form onSubmit={handleSubmit} className="mt-4 space-y-4">
              <div className="grid grid-cols-2 gap-4">
                <Checkbox
                  name="isRush"
                  checked={formValues.isRush}
                  onChange={() => handleFieldChange("isRush")}
                  className="text-gray-700"
                >
                  Rush
                </Checkbox>
                <Checkbox
                  name="isTranslationRequired"
                  checked={formValues.isTranslationRequired}
                  onChange={() => handleFieldChange("isTranslationRequired")}
                  className="text-gray-700"
                >
                  Translation Needed
                </Checkbox>
                <Checkbox
                  name="isTransportationRequired"
                  checked={formValues.isTransportationRequired}
                  onChange={() => handleFieldChange("isTransportationRequired")}
                  className="text-gray-700"
                >
                  Transportation Needed
                </Checkbox>
              </div>
  
              <div className="grid grid-cols-2 gap-4">
                <div>
                  <label htmlFor="injury" className="block text-gray-800 font-semibold">
                    Injury
                  </label>
                  <Input
                    fullWidth
                    size="large"
                    placeholder="Injury"
                    value={formValues.injury || ""}
                    name="injury"
                    id="injury"
                    onChange={(e) => inputChangeHandler(e)}
                    className="w-full border border-gray-300 p-2 rounded-md"
                  />
                </div>
                <div>
                  <label htmlFor="dateOfInjury" className="block text-gray-800 font-semibold">
                    Date Of Injury
                  </label>
                  <Input
                    size="large"
                    type="date"
                    fullWidth
                    onChange={(e) => inputChangeHandler(e)}
                    value={formValues?.dateOfInjury || ""}
                    id="dateOfInjury"
                    name="dateOfInjury"
                    className="w-full border border-gray-300 p-2 rounded-md"
                  />
                </div>
              </div>
  
              <div className="flex justify-end mt-4">
                <FormButtons handleClose={handleEditClose} />
              </div>
            </form>
          ) : (
            <div className="mt-3 space-y-2 text-gray-800">
              <div>
                <b>Rush:</b> {formValues.isRush || claim?.isRush ? "Yes" : "No"}
              </div>
              <div>
                <b>Translation Required:</b>{" "}
                {formValues.isTranslationRequired || claim?.isTranslationRequired ? "Yes" : "No"}
              </div>
              <div>
                <b>Transportation Required:</b>{" "}
                {formValues.isTransportationRequired || claim?.isTransportationRequired ? "Yes" : "No"}
              </div>
            </div>
          )}
        </div>
      </div>
    </>
  </Content>
  

  );
};

export default Claim;
